import { Box, Button, Grid, Modal, Typography } from "@mui/material";
import { modalStyle } from "./Error";
import { useHistory } from "react-router-dom";
import { red } from "./theme";

export function Confirmation(props: any){
    const {display, setDisplay,setIsDirty} = props
    const history = useHistory()
  
  
    return (
 
        <Modal  open={display} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
          
          <Box sx ={modalStyle}>
           
            <Typography sx={{ color: red }} textAlign={"center"}>
       
            </Typography>
        <Typography>Are you sure you want to leave? All of your input will be lost.</Typography>
            <Grid container justifyContent={'space-between'}>   <Button type="button" variant="contained" onClick={() => setIsDirty(false)} sx={{ marginTop: 5, width: "40%" }} color="primary">
              Yes
            </Button>
            <Button type="button" variant="contained" onClick={()=> setIsDirty(false)} sx={{ marginTop: 5, width: "40%" }} color="primary">
              No
            </Button></Grid>
           
          </Box>
          
        </Modal>
  
    );
  }
  